var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StreamlineIcon',{staticClass:"LoadingIcon",attrs:{"icon":_vm.SynchronizeArrows1,"stroke":_vm.color,"fill":_vm.fill,"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }